import React, {Component} from 'react';

import DefaultLayout from './DefaultLayout.jsx';

export default class PageLayout extends Component {
  render() {
    return (
      <DefaultLayout showSidebarMenu={false} className="bg-gray-50">
        <div className="container">
          <div className="row">
            <div className="col-xxl-8 mx-auto bg-white bd-gray-200 p-5 my-5">
              {this.props.children}
            </div>
          </div>
        </div>
      </DefaultLayout>
    );
  }
}